
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-briefing",
      function () {
        return require("private-next-pages/new-briefing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-briefing"])
      });
    }
  